import makeAction from '../../redux/utils/makeAction'
import { SetDateRangeAction } from './types'

const setNumMonths = makeAction<SetDateRangeAction>('dateRange/SET')

export default { setNumMonths }
